import { render } from "./TextParagraph.vue?vue&type=template&id=7435f8e4"
import script from "./TextParagraph.vue?vue&type=script&lang=js"
export * from "./TextParagraph.vue?vue&type=script&lang=js"

import "./TextParagraph.vue?vue&type=style&index=0&id=7435f8e4&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__